<script lang="jsx">
export default {
  data() {
    return {
      lineInfo: {
        enable: false,
        index: -1,
        startPos: [0, 0]
      },
      len: 1,
      bothSizes: [
        ['50%', '100%'],
        ['50%', '100%']
      ],
      singleSize: [['100%', '100%']]
    };
  },
  computed: {
    sizes() {
      return this.len === 2 ? this.bothSizes : this.singleSize;
    }
  },
  methods: {
    makeEvents(index) {
      return {
        mousedown: event => {
          this.lineInfo.enable = true;
          this.lineInfo.index = index;
          this.lineInfo.startPos = [event.clientX, event.clientY];
          this.lineInfo.startSize = JSON.parse(JSON.stringify(this.sizes));
        }
      };
    },
    genWrap(node, index) {
      return (
        <div
          class="split-screen-item"
          style={{
            width: `calc(var(--width${index}) - 1px)`,
            height: `calc(var(--height${index}) - 1px)`
          }}
        >
          {node}
        </div>
      );
    },
    genWraps(nodes) {
      const vns = nodes.map((node, index) => {
        // if (index > 0 && index < nodes.length) {
        //   return [
        //     <div class="split-screen-line" on={this.makeEvents(index)} />,
        //     this.genWrap(node, index)
        //   ];
        // }

        return this.genWrap(node, index);
      });

      return vns.flat(1);
    }
  },
  render() {
    const nodes = this.$slots.default.filter(v => v.tag);

    this.len = nodes.length;

    const items = this.genWraps(nodes);

    const styles = this.sizes.map((e, i) => ({
      ['--width' + i]: e[0],
      ['--height' + i]: e[1]
    }));

    return (
      <div ref="container" style={styles} class="split-screen-wrap">
        {items}
      </div>
    );
  },
  mounted() {
    // this.onLineMousemove = event => {
    //   if (!this.lineInfo.enable) return;
    //   const containerWidth = this.$refs.container.clientWidth;
    //   this.lineInfo.currPos = [event.clientX, event.clientY];
    //   const { startPos, index, startSize } = this.lineInfo;
    //   const dx = event.clientX - startPos[0];
    //   // const dy = event.clientY - this.lineInfo.startPos[1];
    //   const parse = val => {
    //     if (val.includes('%')) {
    //       return (parseInt(val) * containerWidth) / 100;
    //     }
    //     return parseInt(val);
    //   };
    //   const currWidth = parse(startSize[index - 1][0]);
    //   // const currHeight = parse(startSize[1]);
    //   const newWidth = currWidth + dx;
    //   // const newHeight = currHeight + dy;
    //   this.bothSizes[index - 1].splice(0, 1, `${newWidth}px`);
    //   this.bothSizes[index].splice(0, 1, `calc(100% - ${newWidth}px)`);
    //   // this.bothSizes[index - 1].splice(1, 1, `${newHeight}px`);
    // };
    // this.onLineMouseup = () => {
    //   this.lineInfo.enable = false;
    //   this.lineInfo.index = -1;
    //   this.lineInfo.startPos = [];
    //   this.lineInfo.currPos = [];
    // };
    // document.body.addEventListener('mousemove', this.onLineMousemove, { capture: true });
    // document.body.addEventListener('mouseup', this.onLineMouseup, { capture: true });
  },
  beforeDestroy() {
    // document.body.removeEventListener('mousemove', this.onLineMousemove);
    // document.body.removeEventListener('mouseup', this.onLineMouseup);
  }
};
</script>

<style lang="scss">
.split-screen-wrap {
  width: 100%;
  height: 100%;

  .split-screen-line {
    width: 2px;
    height: 100%;
    background: #000;

    cursor: grab;

    &:hover {
      width: 1px;

      background: #0ff;
    }

    &:active {
      cursor: grabbing;
    }
  }
}
</style>
